/* eslint-disable */
import { produce } from "immer";
import {
  FUND_SWITCH_FUTURE_FETCH_FAILURE,
  FUND_SWITCH_FUTURE_FETCH_SUCCESS,
  FUND_SWITCH_FUTURE_FETCH_START,
} from "../actions/types";

const fundSwitchFuture = (
  state = {
    fundSwitchFutureFetching: false,
    fundSwitchFutureData: [],
    fundSwitchFutureError: null,
  },
  action,
) => {
  switch (action.type) {
    case FUND_SWITCH_FUTURE_FETCH_START:
      return produce(state, (draft) => {
        draft.fundSwitchFutureFetching = true;
      });
    case FUND_SWITCH_FUTURE_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fundSwitchFutureFetching = true;
        draft.fundSwitchFutureData = action.data;
        draft.fundSwitchFutureFetching = false;
      });
    case FUND_SWITCH_FUTURE_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fundSwitchFutureFetching = false;
        draft.fundSwitchFutureError = action.error;
      });
    default:
      return state;
  }
};

export default fundSwitchFuture;
